<div class="temp-maintenance-wrapper" data-crlat="underMaintenance">
    <img (click)="reloadOrNavigate()" class="temp-maintenance-popup" [src]="imagePath" />
</div>
